import React from 'react'
import Banner from '../components/Banner'
import Navbar from '../components/Navbar'
import CorporateInsolvency from '../components/CorporateInsolvency'

function CorporateInsolvencyPage() {
    return (
        <div>
            <Banner />
            <Navbar />
            <CorporateInsolvency />
        </div>
    )
}

export default CorporateInsolvencyPage